import React from 'react';

const Services = () => {
  return (
    <section id="services" className="py-20 bg-gray-100">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-bold text-center mb-12">我们的服务</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-xl font-bold mb-4">服务一</h3>
            <p className="text-gray-600">详细的服务描述内容</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-xl font-bold mb-4">服务二</h3>
            <p className="text-gray-600">详细的服务描述内容</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-xl font-bold mb-4">服务三</h3>
            <p className="text-gray-600">详细的服务描述内容</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services; 